export default __webpack_public_path__ + "static/media/Policy-Working-Group-Photo-62.f29d11a0.jpg";